import { useEffect } from 'react';

interface UseFlowKeyboardOptions {
  editing: boolean;
  inlineEditActive: boolean;
  onUndo: () => void;
  onRedo: () => void;
  onSave: () => void;
  onDuplicate: () => void;
  onSelectAll: () => void;
}

export function useFlowKeyboard({
  editing,
  inlineEditActive,
  onUndo,
  onRedo,
  onSave,
  onDuplicate,
  onSelectAll,
}: UseFlowKeyboardOptions) {
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (inlineEditActive) return;

      const ctrl = e.ctrlKey || e.metaKey;
      if (ctrl && e.key === 'z' && !e.shiftKey) {
        e.preventDefault();
        onUndo();
      } else if (ctrl && ((e.key === 'Z' && e.shiftKey) || e.key === 'y')) {
        e.preventDefault();
        onRedo();
      } else if (ctrl && e.key === 's') {
        e.preventDefault();
        onSave();
      } else if (ctrl && e.key === 'd') {
        e.preventDefault();
        onDuplicate();
      } else if (ctrl && e.key === 'a') {
        e.preventDefault();
        onSelectAll();
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [editing, inlineEditActive, onUndo, onRedo, onSave, onDuplicate, onSelectAll]);
}
